import React, { useState } from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';

function SecurityInfo({ checked, onChange, hidden }) {
  return (
    // className={`card col-4 get-notification ${!toggles.notification ? 'card-disabled' : ''}`}
    //<div className={`garden-wall-normal-card my-account-card ${hidden ? 'card-disabled' : ''}`}
    <div
      className={`garden-wall-normal-card my-account-card ${hidden ? 'card-disabled' : ''}`}
    >
      <div className="title-row">
        <div className="section-title-my-account">Security info</div>
        <CustomSwitch
          checked={checked} // from parent
          onChange={onChange} // from parent
          size="small" // small | medium | large
          color="var(--primary-color)"
        />
      </div>
      <div className="my-account-section-row">
        <div className="section-label">Login</div>
        <div className="section-value">loveherman2-2</div>
      </div>
      <div className="divider"></div>
      <div className="my-account-section-row">
        <div className="section-label">Password</div>
        <div className="section-value">
          <div className="password-dot-wrap">
            <span className="password-dot"></span>
            <span className="password-dot"></span>
            <span className="password-dot"></span>
            <span className="password-dot"></span>
            <span className="password-dot"></span>
            <span className="password-dot"></span>
            <span className="password-dot"></span>
            <span className="password-dot"></span>
          </div>
        </div>
      </div>
      <div className="divider"></div>
      <div className="my-account-section-row">
        <div className="section-label">2-Step Verfication</div>
        <div className="section-value">Not Enabled</div>
      </div>
    </div>
  );
}

export default SecurityInfo;
